import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { SecurityService } from '../../security.service';
import { DataStorageService } from '../../data-storage.service';
import { ConfigService } from '../../config.service';
import { BagElement } from '../../../models/bagElement';
import { Device } from '../../../models/device';

interface BagDeviceFromBackend {
  sourceDeviceId: number;
  articleNo: string;
  articleUrl: string;
  name: string;
  description: string;
  manufacturer: string;
  distributor: string;
  purchasePrice: number;
  salePrice: number;
  count: number;
  imageUrl: string;
  hashImage: boolean;
  category: string;
}

@Injectable()
export class ApiBagService {

  constructor(private http: HttpClient,
    private security: SecurityService,
    private dataStorageService: DataStorageService,
    private config: ConfigService) {
  }

  getBagDevice(offerID: number): Promise<BagElement[]> {
    return new Promise<BagElement[]>((resolve, reject) => {
      const url = this.config.host
        + '/api/offer/'
        + offerID
        + '/device';
      this.http.get<{ devices: BagDeviceFromBackend[] }>(url).subscribe(response => {
        const effect = [];
        response.devices.forEach(value => {
          const dev = new Device();
          dev.id = value.sourceDeviceId;
          dev.name = value.name;
          dev.imageUrl = value.imageUrl;
          dev.salePrice = value.salePrice;
          dev.purchasePrice = value.purchasePrice;
          dev.description = value.description;
          dev.distributor = value.distributor;
          dev.manufacturer = value.manufacturer;
          dev.articleNo = parseInt(value.articleNo, 10);
          const be = new BagElement(dev, value.count);
          effect.push(be);
        });
        resolve(effect);
      });
    });
  }

  putBagDevice(deviceID: number, count: number, offerID?: number): Promise<any> {
    offerID = offerID ? offerID : this.dataStorageService.currentState.offerID;
    const url = this.config.host
      + '/api/offer/'
      + offerID
      + '/device'
      + '?id='
      + deviceID
      + '&count='
      + count;

    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<any>((resolve, reject) => {
        this.http.put(url, null).subscribe(() => resolve(), error => {
          if (error instanceof HttpErrorResponse && error.status === 401) {
            this.security.refreshToken()
              .then(() => this.putBagDevice(deviceID, count, offerID).then(() => resolve()));
          } else {
            if (error.status >= 400) {
              alert('ERROR: Please contact with your administrator');
            } else if (error.status === 0) {
              alert('Please check your internet connection');
            }
            reject();
          }
        });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  deleteBagDevice(deviceID: number, offerID?: number): Promise<any> {
    offerID = offerID ? offerID : this.dataStorageService.currentState.offerID;
    const url = this.config.host
      + '/api/offer/'
      + offerID
      + '/device'
      + '?id='
      + deviceID;

    return new Promise<any>((resolve, reject) => {
      this.http.delete(url).subscribe(() => resolve(), error => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          this.security.refreshToken()
            .then(() => this.deleteBagDevice(deviceID, offerID).then(() => resolve()));
        } else {
          alert(error.message);
          reject();
        }
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/apiServices/bag/api-bag.service.ts